import { PricingProfileAddPanel } from "@/components/organisms";

export const PricingProfileAdd = () => (
  <div className="flex min-h-[calc(100vh-120px)] flex-1 flex-col px-5 py-4">
    <PricingProfileAddPanel />
  </div>
);
